<template>
  <div class="modal fade slide-up" id="modal-date-form" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog ">
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <div class="modal-header">
            {{ trans('UnavailabilityCalendar.add_datetime') }}
          </div>

          <div class="modal-body">
            <unavailability-date-form :selectedDate="selectedDate"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/lang'
  import UnavailabilityDateForm from './UnavailabilityDateForm'

  export default {
    name: "UnavailabilityDateFormPopup",
    components: { UnavailabilityDateForm },
    props: ['selectedDate', 'unavailabilityDate'],
    methods: {
      trans(text) {
        return i18n.t(text);
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/unavailabilityCalendars/UnavailabilityDateFormPopup.vue